import React from 'react';
import { Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const FindNotFound = React.memo(() => {
  return (
    <Stack>
      <FormattedMessage id="find.notFound" defaultMessage="Find not found" />
    </Stack>
  );
});

export { FindNotFound };
